export class RiderCashReleaseAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Propose releasing the rider's cash block in a market (the maker); `409 NOTHING_TO_RELEASE` when nothing counts there. */
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/rider-cash-releases', body: input, auth: true });
    }
    /** The checker (never the proposer) approves or rejects. Approving clears the shortfalls recorded in the market up to the decision. */
    decide(releaseId, decision, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/rider-cash-releases/${encodeURIComponent(releaseId)}/${decision}`, body: input, auth: true });
    }
    list(marketId, filter = {}) {
        const q = new URLSearchParams({ market: marketId, ...(filter.riderId !== undefined ? { riderId: filter.riderId } : {}), ...(filter.status !== undefined ? { status: filter.status } : {}) });
        return this.client.request({ method: 'GET', path: `/v1/admin/rider-cash-releases?${q.toString()}`, auth: true });
    }
}
export class WalletReversalAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(marketId, status) {
        const q = new URLSearchParams({ market: marketId, ...(status !== undefined ? { status } : {}) });
        return this.client.request({ method: 'GET', path: `/v1/admin/wallet/top-up-reversals?${q.toString()}`, auth: true });
    }
    /** Finance looks at the item (once; a second acknowledgement keeps the first). */
    acknowledge(reversalId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/wallet/top-up-reversals/${encodeURIComponent(reversalId)}/acknowledge`, body: input, auth: true });
    }
}
/** Q-132: a platform operator confirms the establishment type a store declared (the type-based commission rule applies only then). */
export class StoreTypeConfirmationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    confirm(locationId, establishmentType) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-terms/locations/${encodeURIComponent(locationId)}/establishment-type/confirm`, body: { establishmentType }, auth: true });
    }
}
//# sourceMappingURL=h1-money.js.map